export const token_api = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIzIiwicm9sZSI6ImFkbWluIiwibmFtZSI6InBhY2toYWkiLCJzaG9waWQiOiIiLCJpc3MiOiJwYWNraGFpIiwiYXVkIjoiaHR0cHM6Ly9wYWNraGFpLmNvbSJ9.0VJo-UBFDBCY5m5ldCzTfAYGZLWDsQ27AiZH4LFlup0'

//export const header_token={'Content-Type': 'application/json', 'Authorization': 'Bearer '+localStorage.getItem('authorization_token')}

export const header_token = {
  'Content-Type': 'application/json'
  , 'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIzIiwicm9sZSI6ImFkbWluIiwibmFtZSI6InBhY2toYWkiLCJzaG9waWQiOiIiLCJpc3MiOiJwYWNraGFpIiwiYXVkIjoiaHR0cHM6Ly9wYWNraGFpLmNvbSJ9.0VJo-UBFDBCY5m5ldCzTfAYGZLWDsQ27AiZH4LFlup0'
}
